// 校验数字是否大于0 小于10
export function isvalidNum10(str) {
    const valid_map = /^([1-9]|10)$/;
    return valid_map.test(str);
}

// 校验数字是否大于0 小于30
export function isvalidNum30(str) {
    const valid_map = /^(?:[1-9]|[1-2][0-9]?|30)$/;
    return valid_map.test(str);
}

// 校验数字是否大于0 小于90
export function isvalidNum90(str) {
    const valid_map = /^(?:[1-9]|[1-8][0-9]?|90)$/;
    return valid_map.test(str);
}

// 校验邮箱是否合法
export function isvalidEmail(str) {
    const valid_map = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    return valid_map.test(str);
}

// 校验QQ是否合法
export function isvalidQQ(str) {
    const valid_map = /^[1-9][0-9]{4,10}$/;
    return valid_map.test(str);
}

// 校验code
export function isvalidCode(str) {
    const valid_map = /\d{6}/;
    return valid_map.test(str);
}

// 校验手机号是否合法
export function isvalidMobile(str) {
    const valid_map = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
    return valid_map.test(str);
}
